'use strict';
import React from 'react';
import jpAction from '../../actions/jpAction';
import jpStore from '../../stores/jpStore';
import JpModal from './jpModal';
import genFunction from '../../functions/genFunction';
import userStore from '../../stores/userStore';
import { METHODS } from 'http';

class JPList extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.showOption = this.showOption.bind(this);
        this.handleOption = this.handleOption.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.updateERP = this.updateERP.bind(this);
        this.closeOption = this.closeOption.bind(this);
        //this.updateMileage = this.updateMileage.bind(this);
        this.updateDistance = this.updateDistance.bind(this);
        this.updateParking = this.updateParking.bind(this);
        this.removeJp = this.removeJp.bind(this);
        this.uploadReceipt = this.uploadReceipt.bind(this);
        this.uploadERPReceipt = this.uploadERPReceipt.bind(this);
        this.updateRemark = this.updateRemark.bind(this);
        this.state = {
            title: "",
            jpId: "",
            action: '',
            parkingImage: "",
            erpImage: "",
            googleStart: "",
            googleEnd: "",
            modalClose: false,
            processing: jpStore.getState().processing,

            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId,
        }
    }
    componentDidMount() {
        jpStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
        window.addEventListener("click", this.closeOption);
    }
    componentWillUnmount() {
        jpStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
        window.removeEventListener("click", this.closeOption);
    }
    onChange(state) {
        this.setState({
            processing: state.processing
        });
    }
    onUserChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId
        });
    }
    static defaultProps = {
        mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        statusTxt: ["Approved", "Need Justification", "Rejected", "Pending", "Removed"],
        title: ["Edit ERP", "Edit Parking", "Edit Distance (meter)", "Remove List", "Parking Receipt", "Upload Parking Receipt",
            "Add Remark", "ERP Receipt", "Upload ERP Receipt"]
    };
    handleStatusChange(e) {
        let id = e.target.getAttribute('data-id');
        let status = parseInt(e.target.value);

        if (!this.state.processing) {
            jpAction.processing(true);
            jpAction.updateStatus(id, status);
        }
    }
    handleOption(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        let id = e.target.getAttribute('data-id');
        let action = parseInt(e.target.getAttribute('data-action'));
        let title = this.props.title[action];
        let parkingImage = "", erpImage = "";
        let googleStart = "", googleEnd = "";
        if (action == 4) {
            parkingImage = this.props.journeyList[index].parkingImage;
        } else if (action == 7) {
            erpImage = this.props.journeyList[index].erpImage;
        } else if (action == 2) {
            googleStart = this.props.journeyList[index].googleStart;
            googleEnd = this.props.journeyList[index].googleEnd;
        }
        this.setState({
            jpId: id, modalClose: true, action: action, title: title, parkingImage: parkingImage, erpImage: erpImage,
            googleStart: googleStart, googleEnd: googleEnd
        });
        if (action != 4 && action != 7) {
            jpAction.shouldListShow(index);
        }
    }
    shouldModalClose() {
        this.setState({ modalClose: false });
    }
    updateERP(value) {
        if (!this.state.processing) {
            jpAction.processing(true);
            jpAction.updateERP(this.state.jpId, value);
            this.shouldModalClose();
        }
    }
    updateParking(value) {
        if (!this.state.processing) {
            jpAction.processing(true);
            jpAction.updateParking(this.state.jpId, value);
            this.shouldModalClose();
        }
    }
    /*
    updateMileage(value) {
        if (!this.state.processing) {
            jpAction.processing(true);
            jpAction.updateMileage(this.state.jpId, value);
            this.shouldModalClose();
        }
    }
    */
    updateDistance(value, googleStart, googleEnd) {
        if (!this.state.processing) {
            jpAction.processing(true);
            jpAction.updateDistance(this.state.jpId, value, googleStart, googleEnd);
            this.shouldModalClose();
        }
    }
    removeJp() {
        if (!this.state.processing) {
            jpAction.processing(true);
            jpAction.removeJp(this.state.jpId);
            this.shouldModalClose();
        }
    }
    uploadReceipt(value) {
        if (this.state.processing) return;

        let fd = new FormData();
        if (value) {
            if (value.length > 0) {
                for (let i = 0; i < value.length; i++) {
                    fd.append("images", value[i]);
                }
                fd.append("jpId", this.state.jpId);
                jpAction.processing(true);
                jpAction.uploadReceipt(this.state.jpId, fd);
                this.shouldModalClose();
            }
        }

    }
    updateRemark(value) {
        if (!this.state.processing) {
            jpAction.processing(true);
            jpAction.updateRemark(this.state.jpId, value);
            this.shouldModalClose();
        }
    }
    uploadERPReceipt(value) {
        if (this.state.processing) return;

        let fd = new FormData();
        if (value) {
            if (value.length > 0) {
                for (let i = 0; i < value.length; i++) {
                    fd.append("images", value[i]);
                }
                fd.append("jpId", this.state.jpId);
                jpAction.processing(true);
                jpAction.uploadERPReceipt(this.state.jpId, fd);
                this.shouldModalClose();
            }
        }
    }
    showOption(e) {
        e.preventDefault();
        e.stopPropagation();
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        jpAction.shouldListShow(index);
    }
    closeOption() {
        jpAction.closeListShow();
    }
    renderReceipt(jp, index) {
        if (jp.parkingImage) {
            if (jp.parkingImage.length > 0) {
                return (
                    <div data-index={index} data-id={jp._id} data-action="4" onClick={this.handleOption} style={{ cursor: "pointer" }}>View Parking Receipt</div>
                );
            } else {
                return "--";
            }
        } else {
            return "--";
        }
    }
    renderERPReceipt(jp, index) {
        if (jp.erpImage) {
            if (jp.erpImage.length > 0) {
                return (
                    <div data-index={index} data-id={jp._id} data-action="7" onClick={this.handleOption} style={{ cursor: "pointer" }}>
                        View ERP Receipt
                    </div>
                );
            } else {
                return "--";
            }
        } else {
            return "--";
        }
    }
    renderDataList(jp, index) {
        jp.date = new Date(jp.date);
        jp.startTime = jp.startTime ? new Date(jp.startTime) : "";
        jp.endTime = jp.endTime ? new Date(jp.endTime) : "";
        let date = jp.date.getDate() + "-" + this.props.mthTxt[jp.date.getMonth()] + "-" + jp.date.getFullYear();
        let day = this.props.dayTxt[jp.date.getDay()];
        let timeInHour = "--",
            timeInMinute = "--",
            timeOutHour = "--",
            timeOutMinute = "--";

        if (jp.startTime) {
            timeInHour = (jp.startTime.getHours() < 10 ? "0" + jp.startTime.getHours() : jp.startTime.getHours());
            timeInMinute = (jp.startTime.getMinutes() < 10 ? "0" + jp.startTime.getMinutes() : jp.startTime.getMinutes());
        }
        if (jp.endTime) {
            timeOutHour = (jp.endTime.getHours() < 10 ? "0" + jp.endTime.getHours() : jp.endTime.getHours());
            timeOutMinute = (jp.endTime.getMinutes() < 10 ? "0" + jp.endTime.getMinutes() : jp.endTime.getMinutes());
        }


        return (

            <tr key={index}>
                <td>{date}</td>
                <td>{day}</td>
                <td>{jp.staffId}</td>
                <td>{jp.userName}</td>
                <td>{timeInHour + ":" + timeInMinute}</td>
                <td>{timeOutHour + ":" + timeOutMinute}</td>
                <td>{jp.googleStart}</td>
                <td>{jp.googleEnd}</td>
                <td>{jp.erp ? "$" + jp.erp : "-"}</td>
                <td>{this.renderERPReceipt(jp, index)}</td>
                <td>{jp.parking ? "$" + jp.parking : "-"}</td>
                <td>{this.renderReceipt(jp, index)}</td>
                <td>{jp.distance / 1000}</td>
                <td>{jp.mileageClaim ? "$" + (Math.round(jp.mileageClaim * 100) / 100) : "-"}</td>
                <td>{jp.totalClaim ? "$" + (Math.round(jp.totalClaim * 100) / 100) : "-"}</td>
                <td>{jp.remark ? jp.remark : "-"}</td>
                <td>{this.renderStatus(jp._id, jp.status, index, jp.staffId)}</td>
                <td>
                    {genFunction.hasPermission(this.state.permission, 1) || genFunction.isUser(this.state.userId, jp.staffId) ||
                        genFunction.isSubordinate(this.state.subordinate, jp.staffId)
                        ?
                        <span className="jp-edit glyphicon glyphicon-option-vertical" data-index={index} onClick={this.showOption}></span>
                        : ""
                    }
                    {this.renderEdit(index, jp)}
                </td>
            </tr>

        );
    }

    renderEdit(index, jp) {
        if (genFunction.hasPermission(this.state.permission, 1) || genFunction.isUser(this.state.userId, jp.staffId) ||
            genFunction.isSubordinate(this.state.subordinate, jp.staffId)) {
            if (genFunction.hasPermission(this.state.permission, 1) || jp.status != 0) {
                return (
                    <ul className={"jp-dropdown " + (jp.shouldListShow ? "jp-show" : "jp-hide")} >
                        <li data-action="0" data-id={jp._id} data-index={index} onClick={this.handleOption}>Edit ERP</li>
                        <li data-action="1" data-id={jp._id} data-index={index} onClick={this.handleOption}>Edit Parking</li>
                        {(genFunction.hasPermission(this.state.permission, 1) && this.state.userId != jp.staffId) ||
                            (genFunction.isSubordinate(this.state.subordinate, jp.staffId)) ?
                            <li data-action="2" data-id={jp._id} data-index={index} onClick={this.handleOption}>Edit Distance</li>
                            : ""
                        }
                        <li data-action="5" data-id={jp._id} data-index={index} onClick={this.handleOption}>Upload Parking Receipt</li>
                        <li data-action="8" data-id={jp._id} data-index={index} onClick={this.handleOption}>Upload ERP Receipt</li>
                        <li data-action="6" data-id={jp._id} data-index={index} onClick={this.handleOption}>Add Remark</li>
                        <li data-action="3" data-id={jp._id} data-index={index} onClick={this.handleOption}>Remove</li>
                    </ul>
                );
            }
        }
    }

    renderStatus(jpId, status, index, staffId) {
        if ((genFunction.hasPermission(this.state.permission, 1) && this.state.userId != staffId) ||
            genFunction.isSubordinate(this.state.subordinate, staffId)) {
            return (
                <select className="jp-status form-control input-sm" value={status}
                    data-index={index} data-id={jpId} onChange={this.handleStatusChange}
                >
                    <option value={0} >{this.props.statusTxt[0]}</option>
                    <option value={1} >{this.props.statusTxt[1]}</option>
                    <option value={2} >{this.props.statusTxt[2]}</option>
                    <option value={3} >{this.props.statusTxt[3]}</option>
                    <option value={4} >{this.props.statusTxt[4]}</option>
                </select>
            );
        } else {
            return (this.props.statusTxt[status]);
        }
    }

    renderMainList() {
        if (!this.props.journeyList) return;
        return this.props.journeyList.map((jp, index) => {
            return (
                this.renderDataList(jp, index)
            );
        });
    }

    render() {
        let callBack;
        if (this.state.action == 0) {
            callBack = this.updateERP;
        } else if (this.state.action == 1) {
            callBack = this.updateParking;
        } else if (this.state.action == 2) {
            //callBack = this.updateMileage;
            callBack = this.updateDistance;
        } else if (this.state.action == 3) {
            callBack = this.removeJp;
        } else if (this.state.action == 5) {
            callBack = this.uploadReceipt;
        } else if (this.state.action == 6) {
            callBack = this.updateRemark;
        } else if (this.state.action == 8) {
            callBack = this.uploadERPReceipt;
        }
        let modal = "";
        if (this.state.modalClose) {
            modal = (
                <JpModal
                    modalClose={this.state.modalClose}
                    action={this.state.action}
                    shouldModalClose={this.shouldModalClose}
                    callBack={callBack}
                    title={this.state.title}
                    parkingImage={this.state.parkingImage}
                    erpImage={this.state.erpImage}
                    googleStart={this.state.googleStart}
                    googleEnd={this.state.googleEnd}
                />
            );
        }
        return (
            <div className="atd-abd-wp">
                <div className="atd-em-lt">
                    <table className="jp-tb">
                        <tbody className={"jp-tbd"}>
                            {this.renderMainList()}
                        </tbody>
                    </table>
                </div>
                {modal}
            </div>
        );
    }
}
export default JPList;


// WEBPACK FOOTER //
// ./app/components/jpComponents/jpList.js